// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qRfe","footer":"Form_footer__tbT8X"};